import { FormControl, Input, ListItemText, ListSubheader, MenuItem, Select } from '@mui/material';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  textfield: {
    width: (props) => props.width || '321px',
    height: (props) => props.height || '44px',
    padding: '12px 12px 12px 12px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
  },
  count: {
    width: '15px',
    height: '15px',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '7px',
    transform: 'translateY(-50%)',
    background: '#D9D6FE',
    fontWeight: '500',
    fontSize: '8px',
    color: '#622FEE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '99',
  },
  formControl: {
    width: ({ width }) => width || '100%',
    margin: '0px !important',
    border: 'none',
  },
  gridContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  selectContainer: {
    flexGrow: 1,
  },
  selectedValues: {
    marginLeft: '13px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
  },
  listSubheader: {
    fontFamily: 'Lato !important',
    fontSize: '10px !important',
    fontWeight: '500 !important',
    lineHeight: '30px !important',
    color: '#98A2B3 !important',
    textTransform: 'uppercase',
  },
}));

const CustomGroupBasicDropDown = ({
  handleChange,
  value,
  width,
  height,
  marginBottom,
  list,
  name,
  disabled = false,
  groupKey,
  labelKey,
}) => {
  const styleProps = {
    width,
    height,
    marginBottom,
  };
  const classes = useStyles(styleProps);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const dropdownListItems = () => {
    const items = [];
    const groupedItems = list?.reduce((acc, option) => {
      const group = option[groupKey] || 'Default';
      if (!acc[group]) acc[group] = [];
      acc[group].push(option);
      return acc;
    }, {});

    Object.entries(groupedItems).forEach(([group, options]) => {
      items.push(
        <ListSubheader key={group} className={classes.listSubheader}>
          {group}
        </ListSubheader>,
      );
      options.forEach((option) => {
        items.push(
          <MenuItem key={`${option.id}-${option[labelKey]}`} value={option.id}>
            <ListItemText
              primary={option[labelKey] || option.name || option.displayName}
              primaryTypographyProps={{
                fontFamily: 'Lato',
                fontWeight: '600',
                fontSize: '12px',
                lineHeight: '24px',
                color: '#667085',
              }}
            />
          </MenuItem>,
        );
      });
    });
    return items;
  };

  return (
    <FormControl className={classes.formControl}>
      <Grid container direction="row">
        <Grid item className={classes.selectContainer}>
          <Select
            name={name}
            labelId="grouped-multiple-select-label"
            id="grouped-multiple-select"
            value={value || []}
            onChange={handleChange}
            input={
              <Input
                sx={{ fontFamily: 'Lato', fontWeight: '500', fontSize: '12px' }}
                disableUnderline
                className={classes.textfield}
              />
            }
            MenuProps={MenuProps}
            disabled={disabled}
          >
            {dropdownListItems()}
          </Select>
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default React.memo(CustomGroupBasicDropDown);
